import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { useApi } from "customHooks/useApi";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";

const JobTitleNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/jobtitle/list");
    // const classes = useFormStyles();
    const [t, i18n, readyTranslation] = useTranslation("JOBTITLENEW", {
        useSuspense: false
    });

    const postAddress = `/jobtitle/jobtitlenew`;

    const [addBranchReturn, addBranch] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata("JOBTITLENEW");

    const [valuesFromSource] = useValuesFromSource(metadata, true, {});
    valuesFromSource.deleted = false;

    const [formCompleo, finished] = useCompleoReactHookForm({
        FormType: FormClassic,
        i18nV: i18n,
        metadadosRetorno: metadata,
        postMethod: addBranch,
        postReturn: addBranchReturn,
        ready: readyTranslation,
        valuesFromSource: valuesFromSource,
        t: t,
        secondaryButtonFunction: cancelFunction,
        redirectAddress: "/jobtitle/list"
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (finished && readyTranslation) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default JobTitleNew;
